<script>
  import { pages } from '../../config';
    import { goto } from '../../util';

  export let current = '';
  export let prev = [];
</script>

<nav aria-label="breadcrumb">
  <ul>
    <li>
      <a href={pages.dashboard.url}>
        <i class="ri-home-3-line" />
      </a>
    </li>
    {#if prev.length}
      {#each prev as crumb}
        <li>
          <a href={crumb?.href || '#/'} on:click|preventDefault={() => goto(crumb.href)}>
            {crumb?.label || crumb}
          </a>
        </li>
      {/each}
    {/if}
    {#if current}
      <li>
        {current}
      </li>
    {/if}
  </ul>
</nav>
